import React from "react"
import { useEnterpriseGetList } from "../../hooks/enterprise"
import Link from "next/link"

export default function EnterpriseList() {
  const { enterprises, isLoading, isError } = useEnterpriseGetList()

  if (isLoading) {
    return <p>Загрузка...</p>
  }

  if (isError) {
    return <p>Ошибка: {isError}</p>
  }

  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-1">
      {enterprises &&
        enterprises.map((enterprise) => (
          <div
            key={enterprise.id}
            className="relative flex items-center space-x-3 rounded-lg border border-gray-300 bg-white px-6 py-5 shadow-sm focus-within:ring-2 focus-within:ring-indigo-500 focus-within:ring-offset-2 hover:border-gray-400"
          >
            <div className="min-w-0 flex-1">
              <Link
                href={`/e/${enterprise.id}/`}
                className="focus:outline-none"
              >
                <span className="absolute inset-0" aria-hidden="true" />
                <p className="text-sm font-medium text-gray-900">
                  {enterprise.title}
                </p>
              </Link>
            </div>
          </div>
        ))}
    </div>
  )
}
